import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAnalytics } from '../../contexts/AnalyticsContext';
import {
  Container,
  Box,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import { verifySubscriptionSession } from '../../services/stripeService';

const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { logEvent } = useAnalytics();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifySession = async () => {
      if (!user) {
        setError('Please log in to verify your subscription');
        setLoading(false);
        return;
      }

      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setError('Missing session ID');
        setLoading(false);
        return;
      }
  
      try {
        console.log('Starting verification for:', {
          sessionId,
          userId: user.uid
        });
        
        const result = await verifySubscriptionSession(sessionId);
        console.log('Verification result:', result);
        
        logEvent('subscription_activated', {
          plan: result.planId,
          billingCycle: result.billingCycle
        });
  
        setTimeout(() => {
          navigate('/dashboard');
        }, 3000);
      } catch (error) {
        console.error('Verification error:', error);
        setError(error.message);
        logEvent('subscription_verification_error', { 
          error: error.message,
          sessionId 
        });
      } finally {
        setLoading(false);
      }
    };

    verifySession();
  }, [user, searchParams, navigate, logEvent]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: 'center', py: 8 }}>
        {loading ? (
          <>
            <CircularProgress sx={{ mb: 3 }} />
            <Typography>Activating your subscription...</Typography>
          </>
        ) : error ? (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        ) : (
          <>
            <Typography variant="h4" gutterBottom>
              Welcome to Premium!
            </Typography>
            <Typography color="text.secondary">
              Your subscription has been activated successfully.
              Redirecting to dashboard...
            </Typography>
          </>
        )}
      </Box>
    </Container>
  );
};

export default SubscriptionSuccess;